module.exports = __webpack_public_path__ + "static/targetprocess-3648a7ab6a28d40fc4d287a89533a70d.svg";